import styles from '../ReadSpeaker.css';

export default ($node: HTMLElement) => {
	const $readSpeakers = Array.from(document.querySelectorAll('[data-read-speaker]'));

	const LABEL_ACTION_ENABLE = $node.dataset.labelActionEnable ?? '';
	const LABEL_ACTION_DISABLE = $node.dataset.labelActionDisable ?? '';

	const setCookie = (name: string, value: boolean, expDays: number) => {
		let date = new Date();
		date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = `${name}=${value}; ${expires}; path=/`;
	};

	const getCookie = (name: string) => {
		const cookieName = name + '=';
		const cookieDecoded = decodeURIComponent(document.cookie);
		const cookieArray = cookieDecoded.split('; ');

		let result;

		cookieArray.forEach(cookie => {
			if (cookie.indexOf(cookieName) === 0) {
				result = (cookie.substring(cookieName.length) === 'true');
			}
		});

		return result;
	};

	const setInnerText = (value: any) => $node.innerText = value ? LABEL_ACTION_DISABLE : LABEL_ACTION_ENABLE;

	setInnerText(getCookie('read_speaker'));

	$node.addEventListener('click', () => {
		$readSpeakers.forEach($readSpeaker => $readSpeaker.classList.toggle(styles.isHidden));
		setInnerText(!getCookie('read_speaker'));
		setCookie('read_speaker', !getCookie('read_speaker'), 365);
	});
}
